package app.bloomey.web.components.sections

import androidx.compose.runtime.Composable
import app.bloomey.web.components.widgets.SvgLoader
import app.bloomey.web.core.res.Res
import app.bloomey.web.core.res.adminPage
import app.bloomey.web.core.res.logo
import app.bloomey.web.theme.SpanTextHeader1Variant
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.RowScope
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.layout.breakpoint.displayUntil
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.SilkTheme
import com.varabyte.kobweb.silk.theme.colors.palette.color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun PageToolbar(modifier: Modifier = Modifier, title: String, leading: @Composable RowScope.() -> Unit = {}) {
    val router = rememberPageContext().router
    Row(
        modifier = modifier.fillMaxWidth().height(100.px)
            .borderBottom(width = 0.8.px, style = LineStyle.Solid, color = SilkTheme.palette.color.lightened(0.9f)),
        verticalAlignment = Alignment.CenterVertically
    ) {
        leading()
        SpanText(title, variant = SpanTextHeader1Variant)
        Spacer()
        SvgLoader(
            Res.Assets.logo, modifier = Modifier
                .width(110.px)
                .margin(top = 10.px)
                .displayUntil(Breakpoint.MD)
                .cursor(Cursor.Pointer)
                .onClick { router.navigateTo(Res.Destinations.adminPage) })
    }
}